import { Button, Col, DatePicker, Form, Input, InputNumber, Row, Select, Switch } from 'antd';
import { useEffect, useRef, useState } from 'react'
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import WebEditUniversal, { WEUExtendPropsType } from '../../system/WebEditUniversalNewEx';
import fetchApi from '../../../utils/api/fetchApi';
import getList from '../../universal/getList';
import antMessage from '../../../utils/extend/AntdNotification'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import systematic from '../../../config/systematic';

export default function AliVoiceEdit(props: any) {

    const [form] = Form.useForm(); //form 
    const { data } = props;
    const ref = useRef<any>(undefined);
    const formName = "quotationOrderProducts";
    const formListData = Form.useWatch(formName, form) as any;

    /**产品数据 */
    const [productData, setProductData] = useState<any>();

    const [listDeleteData, setListDeleteData] = useState<Array<any>>([]);

    const handleOk = (e: any) => {
        ref.current.handleOk();
    };

    const handleCancel = (e: any) => {
        ref.current.handleCancel();
    };
    const [buyerData, setBuyerData] = useState<any>();

    /** 后端数据wmService */
    let wmService: any = systematic.wmService;;

    useEffect(() => {
        if (ref.current) {
            // eslint-disable-next-line react-hooks/exhaustive-deps
            wmService = ref.current.wmService;
        }
        if (ref && ref.current) {
            ref.current.row.then(async (res: any) => {

                if (typeof res === 'undefined') { return }
                if (res.success === true) {
                    let productObj: any = {};
                    //自定义formList数据初始状态
                    let newData: Array<any> = [];
                    for (var i = 0; i < res.data[formName].length; i++) {
                        let productId = res.data[formName][i].productId;
                        let productName = res.data[formName][i].productName;
                        let productUnitId = res.data[formName][i].productUnitId;
                        let productUnitName = res.data[formName][i].productUnitName;
                        let selfId = res.data[formName][i].selfId;


                        if (res.data[formName][i].productId) {
                            productObj[i] = [{ id: productId, productName, productUnitId, productUnitName, selfId }]
                            if (data.type === "EDIT") {
                                newData.push({
                                    ...res.data[formName][i],
                                    state: "origin",
                                    originProductId: productId,
                                    productUnitId,
                                    productUnitName,
                                    selfId,
                                    // selfId: res.data[formName][i].product.selfId

                                })

                            }

                        }


                    }

                    form.setFieldsValue({
                        ...res.data,
                        [formName]: newData
                    })
                    setProductData(productObj)

                }
            })
        }
        const fetchData = async () => {


            let buyerData = await fetchApi.GET(wmService, {
                apiId: "buyer",
                apiExtend: 'showList'
            })
            if (buyerData.success) {

                setBuyerData(buyerData.data)
            }
        }
        fetchData()
    }, [])
    //remove 删除
    const removeList = (remove: Function, num: number, key: number) => {
        //即将删除的数据
        let removeData = form.getFieldsValue()[formName!][num];

        if (removeData && removeData.id) {
            setListDeleteData([...listDeleteData, { ...removeData, state: "delete" }])

        }


        remove(num)
        if (productData) {
            delete productData[key]
        }

    }
    let extendProps: WEUExtendPropsType = {
        ...props,
        form,
        apiId: 'quotationOrder',
        dateColumnName: ['startTime', 'endTime'],
    };
    const customizeAdd = (add: Function) => {
        add()
        form.setFieldValue([formName, form.getFieldsValue()[formName].length - 1], { state: "insert" })
    }
    const initProduct = () => {
        let buyerId = form.getFieldValue("buyerId");
        let buyerIds = form.getFieldValue("buyerIds");
        let lastBuyerId = buyerId ? buyerId : (buyerIds ? buyerIds[0] : null);


        // if (!lastBuyerId) return false;
        fetchApi.GET(wmService, {
            apiId: "quotationOrder",
            apiExtend: "initBuyerProduct",
            apiData: {
                buyerId: lastBuyerId
            }
        }).then((res) => {

            if (res.success) {
                let rows = res.data;
                if (rows.length > 0) {
                    let productObj: any = {};
                    //自定义formList数据初始状态
                    let newData: Array<any> = [];
                    for (var i = 0; i <rows.length; i++) {
                        let productId =rows[i].productId;
                        let productName =rows[i].productName;
                        let productUnitId =rows[i].productUnitId;
                        let productUnitName =rows[i].productUnitName;
                        let selfId =rows[i].selfId;
                        if (rows[i].productId) {
                            productObj[i] = [{ id: productId, productName, productUnitId, productUnitName, selfId }]
                            if (data.type === "NEW") {
                                newData.push({
                                    ...rows[i],
                                    state: "insert",
                                    originProductId: productId,
                                    productUnitId,
                                    productUnitName,
                                    selfId,
                                    // selfId: res.data[formName][i].product.selfId

                                })

                            }

                        }


                    }
         
                    form.setFieldsValue({
                        [formName]: newData
                    })
                    setProductData(productObj)
                }
            }

        }).catch((err) => {
            console.log("err", err);

        })

    }
    return (
        <>
            <WebEditUniversal ref={ref} props={extendProps} />
            <AntDraggableModal
                title={(data.type === 'NEW' ? '新增' : '编辑') + '报价订单'}
                open={true}
                okText='确定'
                cancelText='取消'
                onOk={handleOk}
                onCancel={handleCancel}
                closable={false}
                maskClosable={false}
                width={"60%"}
            >
                <Form
                    form={form}
                    name="Edit"
                    onFinish={handleOk}
                >
                    <Row gutter={[8, 0]}>
                        <Col span={24}>
                            <Form.Item
                                label="id"
                                name="id">
                                <Input disabled={true} />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="开始时间"
                                name="startTime"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择时间',
                                    },
                                ]}
                            >
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>
                        <Col span={6}>
                            <Form.Item
                                label="结束时间"
                                name="endTime"
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择时间',
                                    },
                                ]}
                            >
                                <DatePicker
                                    showTime
                                    format="YYYY-MM-DD HH:mm:ss"
                                />
                            </Form.Item>
                        </Col>

                        <Col span={6}>
                            <Form.Item
                                label="采购商"
                                name={data.batch ? "buyerIds" : "buyerId"}
                                rules={[
                                    {
                                        required: true,
                                        message: '请选择采购商',
                                    },
                                ]}
                            >
                                <Select
                                    mode={data.batch ? "multiple" : undefined}
                                    showSearch
                                    placeholder="采购商"
                                    optionFilterProp="children"
                                    // onSearch={(e) => getList.search('dept', setDeptData, e)}
                                    filterOption={(input, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {getList.general(buyerData, 'buyerName')}
                                </Select>
                            </Form.Item>
                        </Col>

                     {data.type ==="NEW"?<Col span={6}>
                            <Form.Item
                                label="初始化"
                                name="init"

                            >
                                <Button onClick={initProduct}>产品数据</Button>
                            </Form.Item>
                        </Col>:null}   

                        <Form.List
                            name={formName}
                            rules={[
                                {
                                    validator: async (_, names) => {
                                        if (!names || names.length < 1) {
                                            antMessage('error', "至少要一个商品", 'error');
                                            return Promise.reject(new Error("至少要一个商品"));
                                        }
                                    },
                                },
                            ]}
                        >
                            {(fields, { add, remove }) => {
                                return (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => {


                                            return (
                                                <Row style={{ width: "100%" }} gutter={4} justify="space-between">
                                                    {/* <Row align={"middle"} justify="center" style={{ display: "flex", justifyContent: "space-between" }}> */}
                                                    <Col className="gutter-row" span={6}>
                                                        <Form.Item

                                                            {...restField}
                                                            label=""
                                                            name={[name, 'productId']}
                                                            rules={[{ required: formListData?.length > 0 && formListData[name] ? formListData[name].productId ? true : false : false, message: '请输入产品!' }]}
                                                        >
                                                            <Select
                                                                optionLabelProp="label"
                                                                style={{ minWidth: 150 }}
                                                                popupMatchSelectWidth={260}
                                                                showSearch
                                                                allowClear
                                                                onSearch={(e) => getList.searchEx('product', setProductData, e, productData, {
                                                                    keyId: key,
                                                                    isFormList: true,
                                                                    form,
                                                                    setObj: ["productId", "productUnitName", "selfId", "productName"],
                                                                    setObjValue: ["id", "productUnitName", "selfId", "productName"],
                                                                    FormListName: formName,
                                                                    name,
                                                                    type: data.type,
                                                                    andWhereObj: {
                                                                        mountDataOptions: {
                                                                            userMount: {
                                                                                isDept: true,
                                                                                isUserAreas: true
                                                                            }
                                                                        }
                                                                    },
                                                                    changeFun: chooseUnit
                                                                })}
                                                                // onChange={(value: any, option: any) => chooseUnit(form, value, option, name, true, formName, type)}
                                                                onChange={(value: any, option: any) => chooseUnit({ form, selectedOptions: option, name, isFormList: true, FormListName: formName, type: data.type })}

                                                                placeholder="品名"
                                                                optionFilterProp="children"
                                                                // onInputKeyDown={(e:any) => getList.search('product', setProductData, e, productData, key, true)}
                                                                filterOption={(input, option: any) => {
                                                                    return true
                                                                }}
                                                            >
                                                                {getList.generalOption(productData ? productData[key] ? productData[key] : [] : [], {
                                                                    itemId: "id", noId: false, label: "productName", children: customizeProduct
                                                                })}
                                                            </Select>


                                                        </Form.Item>
                                                    </Col>
                                                    <Col className="gutter-row" span={2}>
                                                        <Form.Item

                                                            {...restField}
                                                            label=""
                                                            name={[name, 'selfId']}

                                                        >


                                                            <Input disabled placeholder="品号" />


                                                        </Form.Item>
                                                    </Col>

                                                    <Col className="gutter-row" span={2}>
                                                        <Form.Item
                                                            {...restField}
                                                            // label="单位"
                                                            name={[name, 'productUnitName']}

                                                        >
                                                            <Input disabled style={{ "color": "yellow" }} placeholder="单位" />
                                                        </Form.Item>
                                                    </Col>



                                                    <Col className="gutter-row" span={5}>
                                                        <Form.Item
                                                            {...restField}
                                                            // label="规格"
                                                            name={[name, 'productSpecifications']}
                                                        >
                                                            <Input onChange={(e) => changeSpecifications(form, e, name, true, formName, data.type)} placeholder="请输入规格" />
                                                        </Form.Item>
                                                    </Col>



                                                    <Col span={5}>
                                                        <Form.Item
                                                            {...restField}
                                                            name={[name, 'memo']}
                                                        // label="备注"
                                                        >
                                                            <Input onChange={(e) => changeMemo(form, e, name, true, formName, data.type)} placeholder="备注" />
                                                        </Form.Item>
                                                    </Col>








                                                    <Col span={1}>
                                                        <MinusCircleOutlined onClick={() => removeList(remove, name, key)} />
                                                        <div style={{ textAlign: "center" }}></div>
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                        )
                                        }
                                        <Col span={24}>
                                            <Form.Item>
                                                <Button type="dashed" onClick={() => customizeAdd(add)} block icon={<PlusOutlined />}>
                                                    添加商品
                                                </Button>
                                            </Form.Item>
                                        </Col>

                                    </>
                                )
                            }
                            }
                        </Form.List>


                        <Col span={12}>
                            <Form.Item
                                label="状态"
                                name="isUse"
                                valuePropName="checked"
                                initialValue={true}>
                                <Switch checked={true}
                                    checkedChildren="启用"
                                    unCheckedChildren="关闭" />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </AntDraggableModal>
        </>
    )
}
interface chooseUnitObj {
    form: any,
    selectedOptions: any,
    name?: any,
    isFormList?: boolean,
    FormListName?: string,
    type?: string,
    isBigOrder?: boolean
}
/**改变规格 */
const changeSpecifications = (form: any, e: any, name?: any, isFormList?: boolean, FormListName?: string, type?: string) => {
    if (type === "EDIT") form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert" })
}

/**改变备注 */
const changeMemo = (form: any, e: any, name?: any, isFormList?: boolean, FormListName?: string, type?: string) => {
    if (type === "EDIT") form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert" })
}

const chooseUnit = (chooseUnitObj: chooseUnitObj) => {
    const { form, selectedOptions, name, isFormList, FormListName, type } = chooseUnitObj;

    let data = form.getFieldsValue()[FormListName!][name];


    let { selfId, productUnitId, productName, productUnitName } = data;


    if (selectedOptions) {

        selfId = selectedOptions?.children.props.children[0].props.children;
        productUnitId = selectedOptions?.children.props.children[2].props.children;
        productUnitName = selectedOptions?.children.props.children[3].props.children;
        productName = selectedOptions?.children.props.children[1].props.children;
    }







    // let initTotalPrice = 1 * newestUnivalence ? newestUnivalence : 0;

    if (isFormList) {
        form.setFieldValue([FormListName, name, "productUnitId"], productUnitId);
        form.setFieldValue([FormListName, name, "selfId"], selfId);
        form.setFieldValue([FormListName, name, "productUnitName"], productUnitName);






        let upDataObj: any = {
            state: form.getFieldsValue()[FormListName!][name].id ? "update" : "insert",
            productName
        }

        if (type === "EDIT") {





            form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], ...upDataObj })
        }
        if (type === "NEW") {


            form.setFieldValue([FormListName, name], { ...form.getFieldsValue()[FormListName!][name], ...upDataObj })
        }

    } else {
        form.setFieldsValue({
            "selfId": selfId,
            "productUnitId": productUnitId
        });
        // form.setFieldValue("productUnitId", unitName);
    }

    // }



}

/**自定义显示产品数据 */
let customizeProduct = (item: any) => {

    // console.log("item", item);

    return <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>{`${item.selfId ? item.selfId : item.product?.selfId ? item.product?.selfId : "无"}`}</div>
        <div>{`${item.productName ? item.productName : item.product.productName}`}</div>
        <div style={{ display: "none" }}>{`${item.productUnitId}`}</div>
        <div>{item.productUnit?.productUnitName ? item.productUnit?.productUnitName : item.productUnitName}</div>


    </div>
}